import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { customClamshellService } from 'services';
import { UpdateTemplateParams } from 'types';
import { displayNotification } from 'utils';
import { useI18n } from 'contexts/i18n';

export const useUpdateTemplate = () => {
  const queryClient = useQueryClient();
  const i18n = useI18n();
  return useMutation(
    ({
      templateCode,
      templateName,
      logoImage,
      qrcodeImage,
      previewImage,
      webUrl,
      qrcodeText,
      setTemplateMode,
      logo_coordinates,
      web_url_coordinates,
      qrcode_coordinates,
    }: UpdateTemplateParams) => {
      return customClamshellService.updateTemplate(
        templateCode,
        templateName,
        logoImage,
        qrcodeImage,
        previewImage,
        webUrl,
        qrcodeText,
        logo_coordinates,
        web_url_coordinates,
        qrcode_coordinates
      );
    },
    {
      onSuccess: (data, variables, context) => {
        variables.setTemplateMode('list');
        queryClient.invalidateQueries([ServerStateKeysEnum.clamshellTemplates]);
        displayNotification(i18n['Template saved successfully'], 'success');
      },
      onError: (err: AxiosError<{ error: string }>) => {
        displayNotification(i18n['Failed to save the template'], 'danger');
      },
    }
  );
};
